import { render, staticRenderFns } from "./TabScroll.vue?vue&type=template&id=383bb2c4&scoped=true"
import script from "./TabScroll.vue?vue&type=script&lang=js"
export * from "./TabScroll.vue?vue&type=script&lang=js"
import style0 from "./TabScroll.vue?vue&type=style&index=0&id=383bb2c4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383bb2c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('383bb2c4')) {
      api.createRecord('383bb2c4', component.options)
    } else {
      api.reload('383bb2c4', component.options)
    }
    module.hot.accept("./TabScroll.vue?vue&type=template&id=383bb2c4&scoped=true", function () {
      api.rerender('383bb2c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/TagsView/TabScroll.vue"
export default component.exports